import React from "react";
import { Link } from "react-router-dom";

export default function Modal({
  name,
  inputVal,
  changeHandler,
  addWindow,
  closeModalHandler,
  addNewListHandler,
}) {
  return (
    <div>
      <div className={`modal ${addWindow ? "modal-show" : ""}`}>
        <h1 className="create-h1">Create new list</h1>
        <div className="center-div">
          <input
            onChange={changeHandler}
            value={inputVal}
            type="text"
            className="inp-modal"
            placeholder="give it a name.."
          />
          <br />
          <button className="add-desc">Add Description</button>
          <div className="check-div">
            <input type="checkbox" id="private" />
            <label htmlFor="private">Make it Private</label>
          </div>

          <div className="create-can-btns">
            <button className="cancel" onClick={closeModalHandler}>
              Cancel
            </button>
            {inputVal.length > 1 ? (
              <Link to="../saqlangan">
                <button className="create" onClick={addNewListHandler}>
                  Create
                </button>
              </Link>
            ) : (
              <button className="create">Create</button>
            )}
          </div>
        </div>
      </div>
      <div
        onClick={closeModalHandler}
        className={`modal-back ${addWindow ? "modal-show" : ""}`}
      ></div>
    </div>
  );
}
